var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-test-view":"meetings"}},[_c('l-module-access',{attrs:{"module":'meetings',"module-access":_vm.team.moduleAccess,"title":_vm.$t("adminSettings.meetingsHeadlineTitle")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }